// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import {
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
  zIndex,
} from 'presentations/views/styles';
import { gray04, whiteFix } from 'presentations/views/styles/color';
import { useEffect } from 'react';
import BackButton from '../BackButton';

type Props = {
  onClickBack?: () => void;
  backButtonColor?: string;
  formContent: React.ReactNode;
  hostContent: React.ReactNode;
  isUseSticky?: boolean;
  tabletTitle?: string;
};

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <StyledContainer>
      {props.onClickBack && props.backButtonColor && (
        <StyledBackButtonDesktopContainer>
          <BackButton
            onClick={props.onClickBack}
            color={props.backButtonColor}
          />
        </StyledBackButtonDesktopContainer>
      )}
      <StyledFormContent>{props.formContent}</StyledFormContent>
      <StyledBorderLineDesktop />
      <StyledStickySp isUseSticky={props.isUseSticky}>
        <StyledBorderLine />
        <StyledHostContent>{props.hostContent}</StyledHostContent>
        {props.onClickBack && props.backButtonColor && (
          <StyledBackButtonTabletContainer>
            <BackButton
              onClick={props.onClickBack}
              color={props.backButtonColor}
            />
            <StyledTitleSp>{t(props.tabletTitle ?? '')}</StyledTitleSp>
          </StyledBackButtonTabletContainer>
        )}
      </StyledStickySp>
    </StyledContainer>
  );
}

const StyledContainer = styled.div`
  width: 100%;
  min-height: 520px;
  position: relative;
  display: flex;
  padding: ${spacing(40)};
  ${mediaMax.tablet} {
    flex-direction: column-reverse;
    padding: 0 ${spacing(24)};
  }
`;
const StyledFormContent = styled.div`
  flex: 1;
`;
const StyledBorderLine = styled.div`
  margin: 0 ${spacing(40)};
  border-left: 1px solid ${gray04};
  ${mediaMax.tablet} {
    margin: ${spacing(24)} 0;
    border-left: 0;
    border-top: 1px solid ${gray04};
  }
`;
const StyledBorderLineDesktop = styled(StyledBorderLine)`
  ${mediaMax.tablet} {
    display: none;
  }
`;
const StyledHostContent = styled.div`
  flex: 1;
  margin-top: ${spacing(40)};
  ${mediaMax.tablet} {
    margin-top: ${spacing(32)};
  }
  ${mediaMax.smartphone} {
    margin-top: 0;
    flex: none;
  }
`;
const StyledBackButtonDesktopContainer = styled.div`
  position: absolute;
  z-index: ${zIndex(300)};
  top: 36px;
  left: 34px;
  display: block;
  ${mediaMax.tablet} {
    display: none;
  }
`;
const StyledBackButtonTabletContainer = styled.div`
  position: relative;
  z-index: ${zIndex(300)};
  display: none;
  margin-top: ${spacing(24)};
  ${mediaMax.tablet} {
    display: block;
  }
`;
const StyledTitleSp = styled.div`
  display: none;
  position: absolute;
  width: 80%;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: ${fontSize(20)};
  font-weight: ${fontWeight('bold')};
  ${mediaMax.tablet} {
    display: block;
  }
`;
const StyledStickySp = styled.div<{
  isUseSticky?: boolean;
}>`
  flex: 1;
  background-color: ${whiteFix};
  display: flex;
  flex-direction: column-reverse;
  ${mediaMax.tablet} {
    justify-content: flex-end;
    flex: 0 0 0%;
  }
  ${(props) =>
    props.isUseSticky &&
    `
    ${mediaMax.tablet} {
      position: sticky;
      top: 0;
    }
  `}
`;
